/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorPermissionCheckStatusEnum {
  Ok = 'ok',
  MissingScope = 'missingScope',
  MissingApplicationRight = 'missingApplicationRight',
  Forbidden = 'forbidden',
  NotFound = 'notFound',
  Error = 'error'
}
